import { toast } from 'react-toastify'

interface RecoveryLinkModalProps {
    setShowModal: (show: boolean) => void
    recoveryLink: string
}

export const RecoveryLinkModal = ({
    setShowModal,
    recoveryLink,
}: RecoveryLinkModalProps) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(recoveryLink)
        toast.success('¡Enlace copiado al portapapeles!')
    }

    const closeModal = () => setShowModal(false)

    return (
        <div className="main_RecoveryLink">
            <div className="headRecoveryLink">
                <h3>Enlace de recuperación</h3>
                <i className="fas fa-times-circle" onClick={closeModal} />
            </div>
            <div className="bodyRecoveryLink">
                <p>
                    Se ha generado el siguiente enlace para que el usuario pueda restablecer su contraseña:
                </p>
                
                <div className="recovery-link-box">
                    <a href={recoveryLink} target="_blank" rel="noopener noreferrer">
                        {recoveryLink}
                    </a>
                </div>

                <div className="recovery-actions">
                    <button 
                        className="btn-close" 
                        onClick={closeModal}
                    >
                        Cerrar
                    </button>
                    <button 
                        className="btn-copy" 
                        onClick={handleCopy}
                    >
                        <i className="fas fa-copy" />
                        Copiar enlace
                    </button>
                </div>
            </div>
        </div>
    )
}
